'use strict';

module.exports = /&#?(x)?([\w\d]{0,5});/gi;